import { AppName } from '@core/app/scripts/services/app-name';

// remove service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    })
    .catch(function (err) {
      console.log('Service Worker cleanup failed: ', err);
    });
}

const upgradedApps = ['logistic', 'redirect', 'pos'];

require('./app');
angular.module('v6CoreModule');

// TODO SWUI-1725 use modules normaly
require('../../../pos/app/scripts/app');
require('../../../pos/app/scripts/configs/translation');

/*
 * Angular specific configurations
 */
angular
  .module('v6CoreModule')
  .config(
    (
      $httpProvider: ng.IHttpProvider,
      $locationProvider: ng.ILocationProvider,
      $qProvider: ng.IQProvider,
      appName: AppName,
      intercomProvider,
    ) => {
      if (!upgradedApps.includes(appName)) {
        $locationProvider.html5Mode({
          enabled: true,
          requireBase: false,
        });
      }

      delete $httpProvider.defaults.headers.common['X-Requested-With'];
      // @ts-ignore
      $httpProvider.defaults.useXDomain = true;

      intercomProvider.appId = 'hykd9kkf';

      // CORE-814 this prevents Possibly Unhandled Rejections from spamming Sentry
      $qProvider.errorOnUnhandledRejections(false);
    },
  );
